<div class="dashboard-container">
  <!-- Header -->
  <div class="dashboard-header">
    <!-- <h1>Dashboard</h1> -->
    <button mat-fab (click)="refreshData()" [matTooltip]="'dashboard.refresh_tooltip' | translate" [disabled]="isLoading" class="icon-rounded">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <!-- Loading indicator -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>{{ 'dashboard.loading' | translate }}</p>
  </div>

  <!-- Error message -->
  <div *ngIf="errorKey" class="error-message">
    <mat-icon color="warn">error_outline</mat-icon>
    <span>{{ errorKey | translate }}</span>
  </div>

  <!-- Stats Cards -->
  <div class="stats-cards" *ngIf="!isLoading">
    <!-- Operators Card -->
    <mat-card class="stat-card" [class.card-active]="operatorCount > 0">
      <mat-card-header  class="no-padding header-spacings">
        <div mat-card-avatar class="stat-avatar operators">
          <mat-icon>people_alt</mat-icon>
        </div>
        <mat-card-title>{{ operatorCount }}</mat-card-title>
        <mat-card-subtitle>{{ 'dashboard.operators_label' | translate }}</mat-card-subtitle>
      </mat-card-header>
      <!-- <mat-card-content>
        <div class="stat-value">{{ operatorCount }}</div>
        <div class="stat-label">Operatori registrati</div>
      </mat-card-content> -->
    </mat-card>

    <!-- Technicians Card -->
    <mat-card class="stat-card" [class.card-active]="technicianCount > 0">
      <mat-card-header  class="no-padding header-spacings">
        <div mat-card-avatar class="stat-avatar technicians">
          <mat-icon>engineering</mat-icon>
        </div>
        <mat-card-title>{{ technicianCount }}</mat-card-title>
        <mat-card-subtitle>{{ 'dashboard.technicians_label' | translate }}</mat-card-subtitle>
      </mat-card-header>
      <!-- <mat-card-content>
        <div class="stat-value">{{ technicianCount }}</div>
        <div class="stat-label">Tecnici registrati</div>
      </mat-card-content> -->
    </mat-card>
  </div>
</div>
